// var urlBase = process.env.NEXT_PUBLIC_BASE_URL;
import config from '@/localconfig';
import { concantQuery } from './charts_utils';
const urlBase = config.BASE_URL;

const getChartDataSets = function (type, gender, age, measureUnit) {
  return fetch(
    urlBase + '/api/v1/charts?type=' + type + '&gender=' + gender + '&month=' + age + '&measureUnit=' + measureUnit,
  );
};

const getChartDataSetByGenderAndAge = function (type, gender, age) {
  return fetch(urlBase + '/api/v1/charts_info/' + type + '/' + gender + '/' + age);
};

const getP50DataSetByGenderAndAge = function (type, gender, age) {
  return fetch(urlBase + '/api/v1/p_info/' + type + '/' + gender + '/' + age);
};

const getChartLogByDate = async (date, chart_type, gender, age, measureUnit) => {
  // console.log(urlBase + '/api/v1/chart-logs/' + query);
  // TODO // AGE_CONVERSION
  let temp_age = parseInt(age / 12);
  // if (age > 240) {
  //   const remainder = temp_age % 12;
  //   temp_age -= remainder;
  // }
  const query = concantQuery({
    chart_type,
    gender,
    age: temp_age,
    currency: measureUnit,
    startDate: date,
  });
  const res = await fetch(urlBase + '/api/v1/chart-logs/' + query);

  return await res.json();
};

const addChartLogData = async (data) => {
  console.log('data', data);
  const res = await fetch(urlBase + '/api/v1/chart-logs', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(data),
  });
  return await res.json();
};

const uploadImage = async (file) => {
  console.log('uploadImage file', file);
  const formData = new FormData();
  formData.append('file', file);
  const res = await fetch(urlBase + '/api/v1/image/upload', {
    method: 'POST', // Specify HTTP method
    body: formData, // Attach FormData
  });
  return await res.json();
};

export {
  getChartDataSets,
  getChartDataSetByGenderAndAge,
  getP50DataSetByGenderAndAge,
  getChartLogByDate,
  uploadImage,
  addChartLogData,
};
